function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 9.1418C12.3195 9.1418 15.7248 5.10798 15.8677 4.93657C15.9532 4.8339 16 4.70451 16 4.5709C16 4.43728 15.9532 4.30789 15.8677 4.20523C15.7248 4.03382 12.3195 0 8 0C3.6805 0 0.275182 4.03382 0.132342 4.20523C0.046828 4.30789 0 4.43728 0 4.5709C0 4.70451 0.046828 4.8339 0.132342 4.93657C0.275182 5.10798 3.6805 9.1418 8 9.1418ZM8 1.71409C8.56502 1.71409 9.11736 1.88164 9.58716 2.19555C10.057 2.50946 10.4231 2.95563 10.6393 3.47764C10.8556 3.99966 10.9121 4.57407 10.8019 5.12823C10.6917 5.6824 10.4196 6.19144 10.0201 6.59097C9.62054 6.9905 9.1115 7.26259 8.55734 7.37282C8.00317 7.48305 7.42876 7.42647 6.90675 7.21025C6.38473 6.99402 5.93856 6.62786 5.62465 6.15806C5.31074 5.68826 5.14319 5.13592 5.14319 4.5709C5.14319 3.81322 5.44417 3.08658 5.97993 2.55083C6.51569 2.01507 7.24233 1.71409 8 1.71409V1.71409Z",
  fill: "currentColor"
});

function SvgView(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.e3baa811.svg";
export { ForwardRef as ReactComponent };